module.exports = __webpack_public_path__ + "img/green_034.45e53a00.png";